import styled from 'styled-components'

export const NotificationSurface = styled.div.attrs({})`
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 24px 0 8px;
`

export const NotificationText = styled.p.attrs({})`
    margin: 0;
    font-size: 16px;
    line-height: 1.7;
    color: ${({ theme }) => theme.palette.colors.muted};
    max-width: 720px;
`

export const NotificationList = styled.div.attrs({})`
    display: grid;
    gap: 12px;
`

export const NotificationBullet = styled.div.attrs({})`
    position: relative;
    padding-left: 18px;
    font-size: 15px;
    line-height: 1.6;
    color: ${({ theme }) => theme.palette.colors.text};

    &::before {
        content: '';
        position: absolute;
        top: 10px;
        left: 0;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: ${({ theme }) => theme.palette.primary.main};
    }
`

export const ModalActions = styled.div.attrs({})`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 12px;

    @media (max-width: 640px) {
        flex-direction: column-reverse;
    }
`
